import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileIconInactive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.33398 15.666C3.33398 13.4568 5.12484 11.666 7.33398 11.666H12.6673C14.8765 11.666 16.6673 13.4568 16.6673 15.666C16.6673 17.1388 15.4734 18.3327 14.0007 18.3327H6.00065C4.52789 18.3327 3.33398 17.1388 3.33398 15.666Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.334 4.99935C13.334 6.8403 11.8416 8.33268 10.0007 8.33268C8.1597 8.33268 6.66732 6.8403 6.66732 4.99935C6.66732 3.1584 8.1597 1.66602 10.0007 1.66602C11.8416 1.66602 13.334 3.1584 13.334 4.99935Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgProfileIconInactive;
